import { render, staticRenderFns } from "./process-flow.vue?vue&type=template&id=c8c193c0&scoped=true&"
import script from "./process-flow.vue?vue&type=script&lang=js&"
export * from "./process-flow.vue?vue&type=script&lang=js&"
import style0 from "./process-flow.vue?vue&type=style&index=0&id=c8c193c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c193c0",
  null
  
)

export default component.exports